import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { AdminPublicInfo } from '../../Api/Admin/models'
import { GetCbuResponse } from '../../Api/CBU/models'
import { fetchStaticButton } from '../../Api/Buttons/Buttons'
import { Button } from '../../Api/Buttons/models'
import toast from 'react-hot-toast';
import { useGetTimeForHistory } from '../Coins/useGetTimeForHistory';
import { resetUser } from '../../Api/UserPanel/UserPanel';

interface Props {
    adminInfo: AdminPublicInfo | null
    setForm: (form: any) => void
    setLoading: (loading: boolean) => void
    setDropdownOpen: (dropdownOpen: boolean) => void
    fetchedData: GetCbuResponse | null
    form: any
    loading: boolean
    setHistorial: (historial: any[]) => void
    historial: any[]
    setErrorQuantities: (errorQuantities: number) => void
    errorQuantities: number
    showHistory: boolean
    setShowHistory: (showHistory: boolean) => void
}



export const useResetUser = ({
    setForm,
    setLoading,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
    adminInfo
}: Props) => {


    const { getTime } = useGetTimeForHistory()

    const [messagesReset, setMessagesReset] = useState<Button>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',

        Messages: []
    })


    // MAIN FUNCTION
    const handleResetUser = async () => {
        if (loading) { return }
        if (form.name.length < 3) { Swal.fire({ text: 'Para reestablecer ingresa el nombre de usuario completo en el campo de arriba' }); return }

        const copyMessage = async (text: string) => {
            await navigator.clipboard.writeText(text)
            let updatedMessage = text
                .replaceAll('__USUARIO__', (form.name))
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__LINK__', `${adminInfo?.pageLink}`)

            await navigator.clipboard.writeText(updatedMessage);
        }

        let randomIndex = Math.floor(Math.random() * messagesReset?.Messages?.length);
        let randomValue = messagesReset?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)


        let originalName = form.name?.trim() ?? ''
        setForm({ name: '' })

        try {
            const result = await resetUser({ name: originalName })
            console.log(result, 'result reset');
            if (result?.status === 200 && result?.data) {
                toast.success(`Usuario ${originalName} reestablecido`)
                let record = { user: originalName, hour: getTime(), success: true, type: 'Reestablecer' }
                setHistorial([...historial, record])
            } else {

                let record = { user: originalName, hour: getTime(), success: false, type: 'Reestablecer', info: `El usuario no existe, o su contraseña ya es ${adminInfo?.default_users_password ?? "hola123"}` }
                setHistorial([...historial, record])
                if (!showHistory) setErrorQuantities(errorQuantities + 1)
                const errorMessage = result?.response?.data?.msg ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }
        } catch (error: any) {
            let errorMessage = 'ERROR: No se ha podido reestablecer, el usuario no existe, o su contraseña ya es la predeterminada.'
            if (error?.response?.data?.msg) {
                errorMessage = error.response.data.msg
            }
            let record = { user: originalName, hour: getTime(), success: false, type: 'Reestablecer', info: errorMessage }
            setHistorial([...historial, record])
            if (!showHistory) setErrorQuantities(errorQuantities + 1)
            Swal.fire({ icon: 'error', text: errorMessage });
        } finally {
            setLoading(false)
        }



    }


    useEffect(() => {
        fetchStaticButton('static_reset').then((res) => {
            setMessagesReset(res)
        })
    }, [])





    return {
        handleResetUser,
        historial,
        errorQuantities,
        showHistory,
        setShowHistory,
        setErrorQuantities


    }





}
